export const TOAST_ERROR_EXCLUSIONS = [
  { url: '/auth/me', method: 'get', status: 401 },
];

export const shouldSkipErrorToast = error => {
  const status = error.response?.status;
  const url = error.config?.url || '';
  const method = (error.config?.method || '').toLowerCase();

  return TOAST_ERROR_EXCLUSIONS.some(rule => {
    if (rule.status != null && rule.status !== status) {
      return false;
    }
    if (rule.method && rule.method.toLowerCase() !== method) {
      return false;
    }
    if (rule.url && !url.includes(rule.url)) {
      return false;
    }
    return Boolean(rule.status || rule.method || rule.url);
  });
};
